module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section-title has-text-centered"
  }, [_c('p', {
    staticClass: "title is-1"
  }, [_vm._v("\n  \t\t" + _vm._s(_vm.headdata.title.text) + "\n  \t\t"), _c('span', {
    staticClass: "icon is-large"
  }, [(_vm.headdata.title.icon) ? _c('i', {
    class: _vm.headdata.title.icon
  }) : _vm._e()])]), _vm._v(" "), _c('p', {
    staticClass: "subtitle is-3"
  }, [_vm._v("\n\t\t" + _vm._s(_vm.headdata.subtitle.text) + "\n\t\t"), _c('span', {
    staticClass: "icon is-medium"
  }, [(_vm.headdata.subtitle.icon) ? _c('i', {
    class: _vm.headdata.subtitle.icon
  }) : _vm._e()])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-67a67908!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/header.vue
// module id = 275
// module chunks = 2